var React = require('react');

function ContentMap (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Map"),React.createElement("path",{"d":"M2.2,0.2l20.2,7.5c0.5,0.1,0.9,0.6,0.9,1.1v49.3c0,0.9-1.2,1.4-2.2,1.1L0.9,51.7C0.4,51.5,0,51.1,0,50.6V1.3\n\tC0.2,0.4,1-0.1,1.8,0C1.9,0.1,2.1,0.1,2.2,0.2z M55.8,0.2L76,7.7c0.5,0.1,0.9,0.6,0.9,1.1v49.3c0,0.9-1.2,1.4-2.2,1.1l-20.2-7.5\n\tc-0.5-0.1-0.9-0.6-0.9-1.1V1.3C53.5,0.4,54.8-0.2,55.8,0.2z M47.8,0.2L27.6,7.7c-0.5,0.1-0.9,0.6-0.9,1.1v49.3\n\tc0,0.9,1.2,1.4,2.2,1.1l20.2-7.5c0.5-0.1,0.9-0.6,0.9-1.1V1.3C50.1,0.4,48.8-0.2,47.8,0.2z","key":1})]);
}

ContentMap.defaultProps = {"role":"presentation","version":"1.1","x":"0px","y":"0px","viewBox":"0 0 76.9 59.2","style":{"enableBackground":"new 0 0 76.9 59.2"},"xmlSpace":"preserve"};

module.exports = ContentMap;

ContentMap.default = ContentMap;
